import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a22538f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保密")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "设置" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "name",
            label: "姓名",
            name: "name",
            rules: _ctx.rules.name
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.name,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            ref: "gender",
            label: "性别",
            name: "gender"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.gender,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.gender) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 2 }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "phone",
            label: "手机号",
            name: "phone",
            rules: _ctx.rules.mobile
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.phone,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.phone) = $event)),
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_a_form_item, {
            ref: "role_id",
            label: _ctx.menuText.roleName,
            name: "role_id",
            rules: [{ required: true, message: '请选择' + _ctx.menuText.roleName }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.formState.role_id,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.role_id) = $event)),
                mode: "multiple",
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 8, ["label", "rules"]),
          _createVNode(_component_a_form_item, {
            ref: "avatar",
            label: "图片",
            name: "avatar",
            rules: _ctx.rules.image,
            extra: _ctx.pictureExtra
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.avatar,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.avatar) = $event)),
                style: {"display":"none"}
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_UploadComponent, {
                    "on-change": _ctx.onImageChange,
                    "source-url": _ctx.formState.avatar
                  }, null, 8, ["on-change", "source-url"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "extra"]),
          _createVNode(_component_a_form_item, {
            ref: "introduction",
            label: "介绍",
            name: "introduction",
            placeholder: "请输入"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.introduction,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.introduction) = $event)),
                class: "form_hide"
              }, null, 8, ["value"]),
              _createVNode(_component_a_form_item_rest, null, {
                default: _withCtx(() => [
                  _createVNode(_component_EditorComponent, {
                    ref: "editorComponentRef",
                    content: _ctx.formState.introduction
                  }, null, 8, ["content"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}